"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeNextWaitTime = exports.delay = exports.retry = void 0;
/**
 * Default options for retrying.
 */
const defaultOptions = {
    tries: 10,
    factor: 2,
    minTimeout: 1000,
    maxTimeout: Infinity,
};
/**
 * Used to distinguish retry errors.
 */
const SYM_RETRY = Symbol('Retry');
/**
 * Retries the inner function. Works the same as `promise-retry`.
 * @param fn
 */
function retry(fn, opts) {
    return Promise.resolve().then(() => {
        let attempts = 0;
        let waitTime = 0;
        const { tries: retries, factor, minTimeout, maxTimeout } = Object.assign({}, defaultOptions, opts);
        return inner();
        /**
         * The inner function.
         */
        function inner() {
            return Promise.resolve()
                .then(() => fn(getErrorToThrow, ++attempts))
                .catch((err) => {
                if (err === SYM_RETRY) {
                    waitTime = nextWaitTime();
                    return delay(waitTime).then(inner);
                }
                throw err;
            });
        }
        /**
         * Throws the error or a retry error depending on the state.
         * @param err
         */
        function getErrorToThrow(err) {
            if (attempts >= retries) {
                return err;
            }
            return SYM_RETRY;
        }
        /**
         * Gets the next wait time.
         */
        function nextWaitTime() {
            return computeNextWaitTime(minTimeout, maxTimeout, waitTime, factor);
        }
    });
}
exports.retry = retry;
/**
 * Waits for `ms` amount of time.
 */
function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.delay = delay;
/**
 * Computes the next wait time.
 * @param minTimeout
 * @param maxTimeout
 * @param waitTime
 * @param factor
 */
function computeNextWaitTime(minTimeout, maxTimeout, waitTime, factor) {
    return Math.max(Math.min(waitTime * factor, maxTimeout), minTimeout);
}
exports.computeNextWaitTime = computeNextWaitTime;
//# sourceMappingURL=retry.js.map